import React from 'react';

export default class ManageOrderIcon extends React.Component {

    render() {
        return (
            <svg
                xmlns="http://www.w3.org/2000/svg"
                width="22"
                height="22"
                x="0"
                y="0"
                version="1.1"
                viewBox="0 0 72 90"
                xmlSpace="preserve"
            >
                <g transform="translate(-14 -5)">
                    <path d="M74 17V5H14v78h12v12h60V17zM20 77V11h48v6H26v60zm60 12H32V23h48z"></path>
                    <path d="M41 32H47V38H41z"></path>
                    <path d="M53 32H71V38H53z"></path>
                    <path d="M41 46H47V52H41z"></path>
                    <path d="M53 46H71V52H53z"></path>
                    <path d="M41 60H47V66H41z"></path>
                    <path d="M53 60H71V66H53z"></path>
                    <path d="M41 74H47V80H41z"></path>
                    <path d="M53 74H71V80H53z"></path>
                </g>
            </svg>
        )
    }

}
